// Heavily inspired by https://github.com/pespantelis/vue-typeahead

export default {
  data() {
    return {
      query: '',
      queryResults: [],
      current: -1,
      searchCallback: undefined,
      minChars: 1,
    };
  },
  computed: {
    hasResults() {
      return 0 < this.results.length;
    },
    results() {
      return this.queryResults[this.query] ?? [];
    },
  },
  methods: {
    process() {
      if (undefined === this.searchCallback) {
        return; // a search callback has to be defined.
      }
      if (
        undefined !== this.queryResults[this.query]
        || this.minChars > this.query.length
      ) {
        return;
      }
      Promise
        .resolve(this.searchCallback(this.query))
        .then(value => {
          // Convert anything given back by search callback to an array.
          if (Array.isArray(value)) {
            this.queryResults[this.query] = value;
          } else if ('object' === typeof value && null !== value) {
            this.queryResults[this.query] = Object.values(value);
          } else {
            this.queryResults[this.query] = [value];
          }
          this.current = -1;
        });
    },
    reset() {
      this.queryResults = [];
      this.query = '';
    },
    setActive(index) {
      this.current = index;
    },
    up() {
      if (0 < this.current) {
        this.current--;
      } else if (-1 === this.current) {
        this.current = this.results.length - 1;
      } else {
        this.current = -1;
      }
    },
    down() {
      if (this.current < this.results.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }
    },
    onHit() {
      // Has to be implemented by the inheriting component.
    },
  },
};
